const angular = require('angular');

const OrderManagementService = require('./ordermanagement.service');


angular.module('wowApp.shop')
    .service('OrderManagementService', ['$rootScope', 'Restangular', 'RestangularV3', 'BreakpointsService', OrderManagementService]);



// WEBPACK FOOTER //
// ./src/order/ordermanagement/index.js